/**
 * A small picture of a layout: the gallery's sample map, arranged by it and drawn by the real
 * renderer.
 *
 * Shared by the Builder and the AI tab, and cached per layout and font — sixty-four little maps
 * are cheap to draw once and wasteful to draw on every render.
 */
import { layoutSample } from '@orbit-mind/template-catalog';
import type { LayoutId } from '@orbit-mind/shared-types';

import { templatePreviewSrc } from './templatePreview';

const previews = new Map<string, string>();

export function layoutPreviewSrc(id: LayoutId, fontFamily: string): string {
  const key = `${id}|${fontFamily}`;
  let found = previews.get(key);
  if (found === undefined) {
    found = templatePreviewSrc(layoutSample(id), fontFamily);
    previews.set(key, found);
  }
  return found;
}
